(function ($) {
    /* eslint-disable */
    /* global Swiper */

    $('.swiper-team').each(function() {
        var $slider = $(this).closest('.slider');
        var teamSlider = new Swiper(this, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            simulateTouch: false,
            allowTouchMove: false,
            navigation: {
                nextEl: $('.swiper-button-next', $slider).get(0),
                prevEl: $('.swiper-button-prev', $slider).get(0),
            },
            pagination: {
                el: $('.swiper-pagination', $slider).get(0),
                type: 'progressbar',
            },
        });
    });


})( jQuery );


